import { ENV_RENDER_DESIGNER } from '../../utils/constants'

export function getStyle(ch, wrapDragable, spanTem, showExpandSet) {
    const iColWidth = Number(ch.meta.iColWidth);
    return {
        display: ch.visible === false ? 'none' : 'flex',
        width: `calc((${!wrapDragable ? '(100% - 120px)' : '100%'} / ${spanTem}) * ${isNaN(iColWidth) ? 1 : iColWidth})`,
        float: 'left',
        marginBottom: showExpandSet ? 4 : 2,
        maxWidth: `calc(${!wrapDragable ? '(100% - 120px)' : '100%'})`,
        // height: 32,
        justifyContent: 'center'
    }
}

// 是否是设计器态
export function isDesinger(props) {
    return props.renderEnv === ENV_RENDER_DESIGNER
}